import { postPresentSuccess } from '../api/postPresentSuccess';
import { setGetPresentList } from './setGetPresentList';

const setPostPresentSuccess = (params) => {
    return async (dispatch, getState) => {
        try {
            await postPresentSuccess(params);
            dispatch(setGetPresentList({
                page: 1,
                rowsPerPage: 10,
                search: ''
            }));
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostPresentSuccess
}